<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>

<script>
  // import tdTheme from '../theme.json' // 引入默认主题
  import resizeMixins from '@/utils/resizeMixins'

  export default {
    name: 'Echart',
    mixins: [resizeMixins],
    props: {
      className: {
        type: String,
        default: 'chart',
      },
      id: {
        type: String,
        default: 'chart',
      },
      width: {
        type: String,
        default: '100%',
      },
      height: {
        type: String,
        default: '2.5rem',
      },
      options: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        chart: null,
      }
    },
    watch: {
      'options.option': {
        handler(option) {
          // 设置true清空echart缓存
          this.chart.setOption(option, true)
        },
        deep: true,
      },
    },
    mounted() {
      // this.$echarts.registerTheme('tdTheme') // 覆盖默认主题
      this.initChart()
    },
    methods: {
      initChart() {
        // 初始化echart
        this.chart = this.$echarts.init(this.$el)
        this.chart.setOption(this.options.option, true)
      },
    },
  }
</script>

<style></style>
